var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_662_4742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3146 6.8356C13.2108 6.4501 12.9069 6.14615 12.5214 6.04236C11.8171 5.84961 8.99998 5.84961 8.99998 5.84961C8.99998 5.84961 6.18286 5.84961 5.47858 6.03495C5.10049 6.13873 4.78913 6.4501 4.68534 6.8356C4.5 7.53988 4.5 9.00034 4.5 9.00034C4.5 9.00034 4.5 10.4682 4.68534 11.1651C4.78913 11.5506 5.09308 11.8545 5.47858 11.9583C6.19027 12.1511 8.99998 12.1511 8.99998 12.1511C8.99998 12.1511 11.8171 12.1511 12.5214 11.9657C12.9069 11.8619 13.2108 11.558 13.3146 11.1725C13.5 10.4682 13.5 9.00775 13.5 9.00775C13.5 9.00775 13.5074 7.53988 13.3146 6.8356Z",
    fill: "#DC5C44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10254 10.3508L10.4452 9.0016L8.10254 7.65234V10.3508Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_662_4742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(4.5 4.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhite);
export default __webpack_public_path__ + "static/media/youtube-white.2d6b2066dfa556f21e90eabfcad49e67.svg";
export { ForwardRef as ReactComponent };